<template>
    <div :key="`${issue_type}-${module_key}`">

        <div v-if="!report_mode">
            <h3 class="mt-2" v-if="module_key == 'mm_bituminous_concrete_overlay'">Bituminous Concrete Overlay</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_dense_bituminous_concrete_overlay'">Dense Bituminous Concrete Overlay</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_milling'">Milling</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_thermoplastic_road_marking'">Thermoplastic Road Marking</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_shoulder_raising'">Shoulder Raising</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_road_sruds_fixing'">Road Sruds Fixing</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_kerb_topping'">Kerb Topping</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_kerb_painting'">Kerb Painting/Crash Barrier</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_microsurfacing'">Microsurfacing</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_tack_coat'">Tack Coat</h3>
        </div>
        <div v-else>
            <h3 class="mt-2" v-if="module_key == 'mm_bituminous_concrete_overlay'">Bituminous Concrete Overlay Report</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_dense_bituminous_concrete_overlay'">Dense Bituminous Concrete Overlay Report</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_milling'">Milling Report</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_thermoplastic_road_marking'">Thermoplastic Road Marking Report</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_shoulder_raising'">Shoulder Raising Report</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_road_sruds_fixing'">Road Sruds Fixing Report</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_kerb_topping'">Kerb Topping Report</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_kerb_painting'">Kerb Painting/Crash Barrier Report</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_microsurfacing'">Microsurfacing Report</h3>
            <h3 class="mt-2" v-else-if="module_key == 'mm_tack_coat'">Tack Coat Report</h3>
        </div>
        
        <!-- checking view permission  -->
        <template v-if="(!report_mode && viewDPRIssue) || (report_mode && seeReport)">
            <div>
                <vs-row v-if="!embedded_mode">
                    <vs-col vs-xs="12" vs-sm="10" vs-lg="10" class="px-0 pr-2 mb-base">
                        <vs-input
                            v-model="filters.search"
                            placeholder="Type to search"
                            class="w-full"
                        />
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="2" vs-lg="2" class="mb-base p-0">
                        <vx-tooltip text="Add" color="primary" v-if="!report_mode">
                            <router-link :to="{name: 'dpr-entry-add', params: {issue_type: issue_type, module_key: module_key}}">
                                <vs-button color="primary" type="filled" class="w-full" :disabled="loading">
                                    <font-awesome-icon :icon="addIcon" />
                                </vs-button>
                            </router-link>
                        </vx-tooltip>
                        <vx-tooltip text="Refresh Data" color="primary" :class="!report_mode ? 'ml-2' : ''">
                            <vs-button color="primary" type="filled" class="w-full" @click="init()" :disabled="loading">
                                <font-awesome-icon :icon="refreshIcon" :spin="loading" />
                            </vs-button>
                        </vx-tooltip>
                        <vx-tooltip text="Create Excel" color="primary" class="ml-2" v-if="(report_mode && seeReport)">
                            <vs-button color="primary" type="filled" @click="create_excel"  class="ml-2" :disabled="loading">
                                <font-awesome-icon :icon="excel" />
                            </vs-button>
                        </vx-tooltip>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <!-- created on date range filter  -->
                    <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3">
                        <SelectDate :selectedDate.sync="filters.date__gte" label="Date From" />
                        <small class="block text-danger mt-1" v-if="api_errors && api_errors.date__gte">
                            {{ api_errors.date__gte.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3">
                        <SelectDate :selectedDate.sync="filters.date__lte" label="Date To" />
                        <small class="block text-danger mt-1" v-if="api_errors && api_errors.date__lte">
                            {{ api_errors.date__lte.join(', ') }}
                        </small>
                    </vs-col>
                    <!-- Generic Filter For All  -->
                    <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 mb-3 pr-3">
                        <InputSelect
                            :model.sync="filters.data__side"
                            label="Filter By Side"
                            placeholder="Choose ..."
                            container_class="w-auto input-custom-dropdown"
                            :options="side_options"
                            :multiple="false"
                        />
                    </vs-col>
                    <!-- Generic Filter For All  -->
                    <vs-col vs-xs="12" vs-sm="6" vs-lg="3" class="px-0 pr-3 mb-3">
                        <SelectForeign
                            :model.sync="filters.added_by"
                            label="Filter By Reporter"
                            placeholder="Type to Search..."
                            :multiple="false"
                            :load_initial="true"
                            :label_keys="['first_name', 'last_name']"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.organisation_users}?is_active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="true"
                        />
                    </vs-col>
                </vs-row>
    
                <!-- excel part  -->
                <template v-if="report_mode && ongoing_exports.length">
                    <vs-alert color="primary" v-if="loading_exports">
                        Loading Latest Exports, please wait..
                    </vs-alert>
                    <template v-else>
                        <template v-for="(item, index) in ongoing_exports">
                            <vs-alert color="primary" :key="index" class="mb-2">
                                <template v-if="item.status == 'p'">
                                    Your export is pending, please check back in few minutes
                                </template>
                                <template v-else-if="item.status == 's'">
                                    Your export is in queue, please check back in few minutes
                                </template>
                                <template v-else-if="item.status == 'r'">
                                    Your export is being generated, please check back in few minutes
                                </template>
                                <template v-else-if="item.status == 'c'">
                                    Your export has been completed. (<FormatText :text="item.created_on" format="datetime" />) <a :href="item.export_excel" target="_blank" style="float:right;"><vs-button size="small">Download</vs-button></a>
                                </template>
                                <template v-else-if="item.status == 'f'">
                                    Your export has been failed, please request again!
                                </template>
                            </vs-alert>
                        </template>
                    </template>
                </template>
                
                <template v-if="viewDPRIssue">

                    <vs-row class="my-4">
                        <vs-col class="px-0">
                            <vx-card>
                                <div slot="no-body">
                                    <template v-if="issue_type == 'major_maintenance'">
                                        <MajorMaintenance :report_mode="report_mode" :results="results" @do_delete="id => do_delete(id)" :delete_permission="delete_permission" :disabled="loading || submit_disabled" 
                                            :showReview="showReview" @approve="index => do_approve(index)" @reject="index => do_reject(index)" 
                                            :selected_rows.sync="selected_rows" :editIssue="editIssue"
                                        />
                                    </template>
                                </div>
                            </vx-card>
                        </vs-col>
                    </vs-row>

                    <vs-row v-if="total_items" class="mt-3">
                        <vs-pagination :total="total_pages" v-model="current_page" goto class="mx-auto"></vs-pagination>
                    </vs-row>

                    <vs-row v-if="selected_rows.length && showReview" class="mt-base">
                        <vs-col class="text-center">
                            <vs-button type="filled" color="success" @click="do_bulk_approve" :disabled="loading || submit_disabled">Approve Selected ({{ selected_rows.length }})</vs-button>
                            <vs-button class="ml-3" type="filled" color="danger" @click="do_bulk_reject" :disabled="loading || submit_disabled">Reject Selected ({{ selected_rows.length }})</vs-button>
                        </vs-col>
                    </vs-row>
                </template>
            </div>
            <ReviewPopup :is_active.sync="review_popup.active" :action="review_popup.action" :comment.sync="review_popup.data.comment" :disabled="submit_disabled" @submit="handle_review_submit" @cancel="handle_review_cancel" />
            <DeletePopup :is_active.sync="delete_popup.active" :type="`${issue_type.split('_').join(' ')} dpr entry`" @delete_issue="delete_issue" />
        </template>
        <template v-else>
            <PermissionDenied />
        </template>
    </div>
</template>

<script>
import { faPlus, faRedo, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { Request } from '../../utils/requests'

import MajorMaintenance from "./MajorMaintenance/List.vue"
import ReviewPopup from "./Component/ReviewPopup.vue"
import DeletePopup from '../components/DeletePopup.vue';
import moment from 'moment';

export default {
    components: {
        MajorMaintenance,
        ReviewPopup,
        DeletePopup
    },
    props: {
        embedded_mode: {
            default: false
        },
        embedded_filters: {
            default: null
        },
        report_mode: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    data() {
        let offset = parseInt(this.$route.query.offset || 0)
        let limit = parseInt(this.$route.query.limit || 20)

        let current_page = Math.ceil((offset+limit)/limit)

        return  {

            results: [],

            issue_type: this.$route.params.issue_type,
            module_key: this.$route.params.module_key,

            // filters
            side_options: [
                {value: 'median', label: "Median"},
                {value: 'junctions', label: "Junctions"},
                {value: 'rhs', label: "RHS"},
                {value: 'lhs', label: "LHS"},
            ],

            next_url: null,
            loading: false,
            total_items: null,
            current_page: current_page,
            filters: {
                ordering: this.$route.query.ordering || [],
                search: this.$route.query.search || null,
                offset: offset,
                limit: limit,
            },

            filters_init: false,

            review_popup: {
                active: false,
                index: null,
                action: null,
                data: {
                    comment: null
                }
            },

            delete_popup: {
                active: false,
                id: null
            },

            selected_rows: [],
            submit_disabled: false,
            api_errors: {},

            loading_exports: false,
            ongoing_exports: []
        }
    },
    computed: {
        total_pages() {
            if(this.total_items == 0 || this.filters.limit == 0)  return 1
            return Math.ceil(this.total_items/this.filters.limit)
        },
        addIcon: () => faPlus,
        refreshIcon: () => faRedo,
        excel: () => faFileExcel,
        viewDPRIssue() { 
            return this.hasAccess('read', `dpr_issue_${this.module_key}`, ['all', 'own'])
        },
        showReview() { 
            return this.hasAccess('review', `dpr_issue_${this.module_key}`, 'all') 
        },
        seeReport() {
            return this.hasAccess('read', `dpr_issue_${this.module_key}_report`, 'all')
        }
    },
    mounted() {
        this.init()
    },
    watch: {
        filters: {
            deep: true,
            handler(newV) {
                if (!this.filters_init) return

                if(this.current_page == null) return

                if(this.timer) clearTimeout(this.timer)

                this.selected_rows = []

                this.timer = setTimeout(() => {
                    this.$router.push({name: this.$route.name, query: newV})
                }, 800)
            }
        },
        report_mode(newV) {
            if (newV) this.refresh_exports()
        },
        '$route.query'(newV) {
            this.load_data(newV)
        },
        current_page(newV, oldV) {
            if(newV == oldV) return
            this.filters.offset = (newV-1) * this.filters.limit
        },
        '$route.params.issue_type'() {
            this.init()
        },
        '$route.params.module_key'() {
            this.init()
        },
    },
    beforeDestroy() {
        if (this.export_timer) clearTimeout(this.export_timer)
    },
    methods: {
        init() {
            this.issue_type = this.$route.params.issue_type
            this.module_key = this.$route.params.module_key,
            this.load_filters()
            if (this.report_mode)
                this.refresh_exports()
            this.selected_rows = []
            // this.load_data(this.filters)
        },
        refresh_exports() {
            this.loading_exports = true

            let url = this.$store.state.apiendpoints.excel_list

            let payload = {
                created_on: moment().format('YYYY-MM-DD'),
                module_key: 'd',
                params__issue_type: this.issue_type,
                params__dpr_type: this.module_key,
                limit: 4
            }

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.ongoing_exports = res.results
                    this.loading_exports = false
                    if(this.ongoing_exports.filter((item) => ['p', 's', 'r'].includes(item.status)).length != 0) this.auto_refresh_export()
                }, 
                (err) => {
                    this.loading_exports = false;
                    this.$vs.notify({
                        time: 2500,
                        title: 'Error',
                        text: "Unable to load current exports, please refresh to try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        auto_refresh_export() {
            this.export_timer = setTimeout(() => {
                this.refresh_exports()
            }, 5000);
        },
        create_excel() {

            this.loading = true;
            this.$vs.loading();

            let corrected_keys = {}

            Object.keys(this.filters).filter((key) => !['search', 'ordering', 'offset', 'limit'].includes(key) && this.filters[key]).forEach(key => {
                corrected_keys[key] = this.filters[key]
            })

            let payload = {
                module_key: 'd',
                params: {
                    "issue_type": this.issue_type,
                    "filters": corrected_keys,
                    "dpr_type": this.module_key
                }
            }

            let url = this.$store.state.apiendpoints.excel_create

            Request(this, 'POST', url, null, payload).then(
                (res) => {
                    this.loading = false;
                    this.$vs.loading.close();

                    this.refresh_exports()

                    this.$vs.notify({
                        time: 3000,
                        title: 'Success',
                        text: "Your request to download file has been submitted",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                (err) => {
                    this.loading = false;
                    this.$vs.loading.close();
                    if (err.error) {
                        this.api_errors = err.error

                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        calculate_page() {
            if(this.filters.offset == 0)
                this.current_page = 1
            else
                this.current_page = Math.ceil(this.filters.offset / this.filters.limit)
        },
        load_filters() {

            this.filters_init = false
            this.filters = {
                search: this.filters.search,
                ordering: this.filters.ordering,
                offset: this.filters.offset,
                limit: this.filters.limit,
                data__side: null,
                added_by: null,
                date__lte: null,
                date__gte: null
            }

            this.filters_init = true
        },
        load_data(filters=null) {

            // checking for date range filters
            if (filters.date__gte && !filters.date__lte) {
                this.api_errors = {
                    "date__lte": [
                        "Date to should be there.",
                    ]
                }
                return

            } else if(filters.date__lte && !filters.date__gte) {
                this.api_errors = {
                    "date__gte": [
                        "Date from should be there.",
                    ]
                }
                return
            }

            this.loading = true;
            this.$vs.loading();

            let url = this.$store.state.apiendpoints.dpr_entry_list
            let payload = filters

            if (!payload) payload = {};

            if (this.embedded_mode && this.embedded_filters) {
                payload = { ...payload, ...this.embedded_filters };
            }

            this.api_errors = {}

            payload['issue_type'] = this.issue_type
            payload['module_key'] = this.module_key

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.loading = false
                    this.$vs.loading.close()
                    this.results = res.results
                    this.total_items = res.count
                    this.next_url = res.next
                    this.selected_rows = []
                    if(this.report_mode) this.refresh_exports()
                },
                (err) => {
                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: 'An Error Occured. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                    this.loading = false
                    this.$vs.loading.close()
                }
            )
        },
        do_approve(index, skip_confirmation=false) {
            if (skip_confirmation) {
                this.do_action(index, 'approve', null, false)
            } else {
                this.review_popup.action = 'approve'
                this.review_popup.index = index
                this.review_popup.data.comment = null
                this.review_popup.active = true
            }
        },
        do_bulk_approve() {
            this.selected_rows.forEach(index => this.do_approve(index, true))
            this.selected_rows = []
        },
        do_bulk_reject() {
            this.selected_rows.forEach(index => this.do_reject(index, true))
            this.selected_rows = []
        },
        do_reject(index, skip_confirmation=false) {
            if (skip_confirmation) {
                this.do_action(index, 'reject', null, false)
            } else {
                this.review_popup.action = 'reject'
                this.review_popup.index = index
                this.review_popup.data.comment = null
                this.review_popup.active = true
            }
        },
        handle_review_cancel() {
            this.review_popup.action = null
            this.review_popup.index = null
            this.review_popup.data.comment = null
            this.review_popup.active = false
        },
        handle_review_submit() {
            this.do_action(this.review_popup.index, this.review_popup.action, this.review_popup.data.comment, true)
        },
        do_action(index, action, comment, notify=true) {
            let payload = {
                action,
                comment
            }

            this.submit_disabled = true

            this.$set(this.results[index], 'status', 'u')

            let id = this.results[index].id

            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.dpr_entry_issue_action, id), null, payload).then(
                () => {
                    this.submit_disabled = false

                    if (action == 'approve')
                    this.$set(this.results[index], 'status', 'a')
                    else if (action == 'reject')
                    this.$set(this.results[index], 'status', 'r')

                    if (notify)
                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: "Action completed successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                    this.handle_review_cancel()
                },
                err => {
                    this.submit_disabled = false
                    if (['approve', 'reject'].includes(action))
                        this.$set(this.results[index], 'status', 'p')

                    if (notify)
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "An error occurred while processing your request. Please try again.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                }
            )
        },
        do_delete(id) {
            this.delete_popup.active = true
            this.delete_popup.id = id
        },
        delete_issue() {

            let url = this.$store.state.apiendpoints.dpr_entry + this.delete_popup.id + "/"
            this.disabled = true

            Request(this, 'DELETE', url, null, null).then(
                (res) => {
                    // after successful deletion removing from results
                    this.results = this.results.filter(obj => obj.id != this.delete_popup.id)
                    this.delete_popup.active = false
                    this.delete_popup.id = null
                    this.disabled = false
                    this.$vs.loading.close()
                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: 'DPR entry deleted successfully.',
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                (err) => {
                    this.delete_popup.active = false
                    this.delete_popup.id = null
                    this.disabled = false
                    this.$vs.loading.close()

                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        deleteDPRIssue(item) {
            return this.hasAccess('delete', `dpr_issue_${item.module_key}`, ['all', 'own'], [item.added_by.id])
        },
        delete_permission(item) {
            if(!this.deleteDPRIssue(item)) return false

            const issue_month = (new Date(item.created_on)).getMonth()
            const current_month = (new Date()).getMonth()

            if(issue_month==current_month) return true

            return false
        },
        editIssue(item) { 
            return this.hasAccess('edit', `dpr_issue_${item.module_key}`, ['all', 'own'], [item.added_by.id])
        }
    }
}
</script>

<style lang="scss">
    .tooltip-actions {
      .con-vs-tooltip {
        display: inline-flex;
      }
    }
</style>
